


































import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import { WidgetModel } from '@/_models/WidgetModel'
import { FeatureWidget } from '@/_enums/widget_setting'

import IndoorOutdoorMixin from '../mixins/IndoorOutdoorMixin.vue'
import UserModel from '@/_models/UserModel'

@Component({
  components: {},
})
export default class WidgetsWrapper extends mixins(IndoorOutdoorMixin) {
  featureWidget = FeatureWidget
  isFirstLoading: boolean = true

  // interval for check all resource is loaded
  intervalInit

  widgetFeatureComponents = {
    [FeatureWidget.indoor]: () => import('../indoor/IndoorDisplay.vue'),
    [FeatureWidget.outdoor]: () => import('../outdoor/OutdoorDisplay.vue'),
    [FeatureWidget.user_search]: () => import('../user/UserSearchList.vue'),
  }

  get widgetSettingsData(): WidgetModel[] {
    return this.$store.state.settings.widgets
  }

  get widgetRowCount() {
    return this.$store.state.settings.rowCount
  }

  get isLoading(): boolean {
    return this.$store.state.beacons.loading || this.isFirstLoading
  }

  displayMakersOnMap() {
    if (!this.$refs.mapComponent) {
      return
    }

    for (const mapRef of this.$refs.mapComponent as any[]) {
      if (mapRef && mapRef.displayMakers) {
        mapRef.displayMakers()

        if (mapRef.setEnvDisplay) {
          mapRef.setEnvDisplay()
        }
      }
    }
  }

  onSelectedUser(checkedRows: UserModel[]) {
    if (!this.$refs.mapComponent) {
      return
    }

    for (const mapRef of this.$refs.mapComponent as any[]) {
      if (mapRef && mapRef.checkedRows) {
        mapRef.checkedRows = checkedRows
      }
    }
  }

  // After page created
  async created() {
    await this.$store.dispatch('settings/getFromLocal')
    await this.$store.dispatch('cards/getAll', { card_type: 'all' })
    await this.$store.dispatch('beacons/getAll')

    if (!this.users.length) {
      await this.$store.dispatch('users/getAll', { floor: 'all' })
    }

    // Disable navi feature
    this.shouldFetchDripNavi = false

    const isHaveUseWidget = this.widgetSettingsData.find(
      (item) => item.feature === FeatureWidget.indoor || item.feature === FeatureWidget.outdoor
    )

    this.selectedFloorEnvIds = this.widgetSettingsData
      .filter((item) => item.feature === FeatureWidget.indoor)
      .map((setting) => (setting.options as any)?.floor)

    if (!!isHaveUseWidget) {
      await this.$store.dispatch('floors/getAll')
    }

    this.isFirstLoading = false
  }

  mounted() {
    this.intervalInit = setInterval(() => {
      if (!this.isFirstLoading) {
        clearInterval(this.intervalInit)
        this.refreshUsersInFloor(this.displayMakersOnMap)
      }
    }, 500)
  }

  beforeDestroy() {
    this.$store.dispatch('users/clearSetTimeOut')
    clearTimeout(this.refreshTimer)
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval)
    }
    if (this.intervalInit) {
      clearInterval(this.intervalInit)
    }

    this.$store.dispatch('resetAllModulesState', ['geofences', 'users'])
  }
}
